/* ee-swipe.js — Eyewear Essentials
   Colour navigation for product cards: swipe, drag, prev/next, colour dots, keyboard.
   Additive layer. Takes over [data-card-next] so there is one source of truth. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SWIPE_MIN = 40;   /* px before a drag counts as a colour change */
  var AXIS_LOCK = 8;    /* px before we decide horizontal vs vertical */

  function readColours(media) {
    var tag = media.querySelector('script[type="application/json"]');
    if (!tag) return null;
    try {
      var data = JSON.parse(tag.textContent);
      return (Array.isArray(data) && data.length > 1) ? data : null;
    } catch (err) { return null; }
  }

  function buildSrcset(src) {
    if (!/width=\d+/.test(src)) return '';
    return [240, 400, 600, 800].map(function (w) {
      return src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function preload(src) { if (src) { var i = new Image(); i.src = src; } }

  function setupCard(article) {
    var media = article.querySelector('.ee-card-media');
    if (!media || media.dataset.eeSwipe) return;
    var colours = readColours(media);
    if (!colours) return;

    var img     = media.querySelector('img');
    var link    = media.querySelector('a.ee-product-image');
    var count   = media.querySelector('[data-card-count]');
    var title   = article.querySelector('.ee-card-title');
    var colourEl= article.querySelector('.ee-card-colour');
    var priceEl = article.querySelector('.ee-card-price');
    var soldEl  = article.querySelector('[data-card-sold-out]');
    if (!img) return;

    media.dataset.eeSwipe = 'on';
    var index = 0;

    /* ---- controls -------------------------------------------------- */
    var nav = document.createElement('div');
    nav.className = 'ee-swipe-nav';
    nav.innerHTML =
      '<button type="button" class="ee-swipe-arrow ee-swipe-prev" aria-label="Previous colour">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5 8 12l7 7"/></svg>' +
      '</button>' +
      '<button type="button" class="ee-swipe-arrow ee-swipe-next" aria-label="Next colour">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>' +
      '</button>';
    media.appendChild(nav);

    var dots = document.createElement('div');
    dots.className = 'ee-swipe-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Colours');
    colours.forEach(function (c, n) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'ee-swipe-dot';
      d.setAttribute('role', 'tab');
      d.setAttribute('aria-label', c.colour || ('Colour ' + (n + 1)));
      d.setAttribute('aria-selected', n === 0 ? 'true' : 'false');
      d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(n); });
      dots.appendChild(d);
    });
    media.appendChild(dots);

    /* screen-reader announcement without hijacking the visible counter */
    var live = document.createElement('span');
    live.className = 'ee-swipe-sr';
    live.setAttribute('aria-live', 'polite');
    media.appendChild(live);

    /* ---- render ---------------------------------------------------- */
    function go(n, announce) {
      var len = colours.length;
      index = ((n % len) + len) % len;
      var c = colours[index];

      img.src = c.src;
      var ss = buildSrcset(c.src);
      if (ss) img.srcset = ss;
      if (c.alt) img.alt = c.alt;

      if (link && c.url) { link.href = c.url; if (c.title) link.setAttribute('aria-label', c.title); }
      if (title && c.url) title.href = c.url;
      if (colourEl && c.colour) colourEl.textContent = c.colour;
      if (priceEl && c.price) priceEl.textContent = c.price;
      if (count) count.textContent = (index + 1) + ' / ' + len;
      if (soldEl) soldEl.hidden = c.available !== false;

      Array.prototype.forEach.call(dots.children, function (d, n2) {
        d.setAttribute('aria-selected', n2 === index ? 'true' : 'false');
      });

      if (announce) live.textContent = (c.colour || '') + ', ' + (index + 1) + ' of ' + len;

      if (!REDUCE) {
        img.classList.remove('ee-swipe-in');
        void img.offsetWidth;
        img.classList.add('ee-swipe-in');
      }
      preload((colours[(index + 1) % len] || {}).src);
      preload((colours[(index - 1 + len) % len] || {}).src);
    }

    nav.querySelector('.ee-swipe-prev').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); go(index - 1, true);
    });
    nav.querySelector('.ee-swipe-next').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); go(index + 1, true);
    });

    /* keyboard: arrows when the card has focus */
    article.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); e.stopPropagation(); go(index + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); e.stopPropagation(); go(index - 1, true); }
    }, true);

    /* ---- swipe / drag ---------------------------------------------- */
    var startX = 0, startY = 0, dx = 0, axis = null, active = false, moved = false;

    media.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.stopPropagation();                 /* this layer owns the gesture; the card's own swipe stays quiet */
      active = true; moved = false; axis = null;
      startX = e.clientX; startY = e.clientY; dx = 0;
      img.style.transition = 'none';
    }, true);

    media.addEventListener('pointermove', function (e) {
      if (!active) return;
      e.stopPropagation();
      dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!axis) {
        if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') { media.classList.add('ee-swipe-dragging'); try { media.setPointerCapture(e.pointerId); } catch (err) {} }
      }
      if (axis !== 'x') return;
      moved = Math.abs(dx) > 6;
      if (e.cancelable) e.preventDefault();
      if (!REDUCE) img.style.transform = 'translateX(' + (dx * 0.28) + 'px)';
    }, true);

    function release() {
      if (!active) return;
      active = false;
      media.classList.remove('ee-swipe-dragging');
      img.style.transition = '';
      img.style.transform = '';
      if (axis === 'x' && Math.abs(dx) > SWIPE_MIN) go(dx < 0 ? index + 1 : index - 1, true);
      if (moved) suppressUntil = Date.now() + 400;
      axis = null;
    }
    function releaseEv(e) { if (active) e.stopPropagation(); release(); }
    media.addEventListener('pointerup', releaseEv, true);
    media.addEventListener('pointercancel', releaseEv, true);
    media.addEventListener('lostpointercapture', release);

    /* a drag must never follow the product link: only the click right after a swipe, only on the link */
    var suppressUntil = 0;
    media.addEventListener('click', function (e) {
      if (Date.now() < suppressUntil && e.target.closest('a')) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    go(0, false);
  }

  /* Take over the theme's own "Next colour" button so only this layer drives state. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-card-next]');
    if (!btn) return;
    var article = btn.closest('[data-ee-card]');
    if (!article || !article.querySelector('.ee-card-media[data-ee-swipe]')) return;
    e.preventDefault();
    e.stopPropagation();
    var nx = article.querySelector('.ee-swipe-next');
    if (nx) nx.click();
  }, true);

  function init(root) {
    (root || document).querySelectorAll('[data-ee-card]').forEach(setupCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  /* sections re-rendered by the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
